import * as React from "react";
import { EventCardPropsMapper } from "../../../../helpers/CardProps";
import { EventCardPicker } from "../EventCardPicker";
export const EventListView = (props) => {
    const innerView = [];
    let startIndex = props.startIndex;
    for (startIndex; startIndex < props.endIndex; startIndex++) {
        const sportEvent = props.events[startIndex];
        const cardProps = EventCardPropsMapper[sportEvent.type](props.state, sportEvent, props.cms, props.dict);
        innerView.push(React.createElement(EventCardPicker, Object.assign({ key: `k_card_${startIndex}` }, cardProps)));
    }
    return React.createElement(React.Fragment, null, innerView);
};
//# sourceMappingURL=EventListView.js.map